module.exports = __webpack_public_path__ + "static/media/merge.824e4902.svg";